import cx from 'classnames';
import React from 'react';
import styles from './info-section.module.css';

export const BasicInfoSection = ({ className, title, icon = null, children }) => {
  return (
    <div className={cx(styles.detailsWrapper, className)}>
      {title && (
        <header>
          <span>{title}</span>
          {icon}
        </header>
      )}
      <div className={styles.statSummary}>{children}</div>
    </div>
  );
};
